// BlogAdd.js - Updated with CKEditor Integration
import React, { useReducer, useState, useCallback, useEffect } from "react";
import {
    Row,
    Col,
    Card,
    CardBody,
    CardHeader,
    Form,
    FormGroup,
    Label,
    Input,
    Button
} from "reactstrap";
import { useNavigate, useLocation } from "react-router-dom";
// helpers
import handleReducer, { textChange, onBlur } from "../lib/handleChange";
import toastAlert from "../lib/toastAlert";
import isEmpty from "../lib/isEmpty";

// api
import { editBlogFaq } from "../api/admin";
// validation
import { editBlogFaqValid } from "../validation/admin.validation";
// components
import ButtonLoader from "../mycomponents/Layout/ButtonLoader";
import FieldError from "../mycomponents/Layout/FieldError";

const initialFormValue = {
    question: "",
    answer: "",
};

const BlogFagEdit = () => {
    // hooks
    const navigate = useNavigate();
    const { state } = useLocation();

    const [formValue, setFormValue] = useReducer(handleReducer, initialFormValue);
    const [errors, setErrors] = useState({});
    const [touched, setTouched] = useState({});
    const [loader, setLoader] = useState(false);

    const { question, answer } = formValue;

    const handleChange = (e) => textChange(e, setFormValue);
    const handleBlur = (e) => onBlur(e, setTouched);

    const handleSubmit = useCallback(
        async (e) => {
            e.preventDefault();
            try {
                setLoader(true);
                let jsonData = { ...formValue };
                delete jsonData.status;
                delete jsonData.blogTitle;
                delete jsonData.createdAt;
                delete jsonData.updatedAt;
                const { status, message, errors } = await editBlogFaq(jsonData);
                setLoader(false);
                if (status === true) {
                    toastAlert("success", message, "faq");
                    setFormValue({ type: "RESET", value: initialFormValue });
                    navigate(`/blog-faq-list/${state?.blogId}`);
                } else if (errors) {
                    setErrors(errors);
                } else if (message) {
                    toastAlert("error", message, "faq");
                }
            } catch (err) {
                console.log(err, "errrr");
                setLoader(false);
            }
        },
        [formValue, navigate]
    );

    useEffect(() => {
        const { status, errors } = editBlogFaqValid(formValue);
        if (!status) setErrors(errors);
        else setErrors({});
    }, [formValue]);

    useEffect(() => {
        if (!isEmpty(state)) setFormValue({ type: 'INITIAL_SET', value: state })
    }, [state]);

    return (
        <Row>
            <Col xl={12}>
                <Card>
                    <CardHeader>Edit Blog Faq -({state?.blogTitle})</CardHeader>
                    <CardBody>
                        <Form>
                            <Row>
                                {/* Left column */}
                                <Col md={6}>
                                    <FormGroup>
                                        <Label>Question</Label>
                                        <Input
                                            type="text"
                                            name="question"
                                            value={question}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Enter question"
                                        />
                                        <FieldError name="question" touched={touched} errors={errors} />
                                    </FormGroup>

                                    <FormGroup>
                                        <Label>Answer</Label>
                                        <Input
                                            type="textarea"
                                            name="answer"
                                            value={answer}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Answer"
                                            rows={8}
                                        />
                                        <FieldError
                                            name="answer"
                                            touched={touched}
                                            errors={errors}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>

                            <ButtonLoader
                                loader={loader}
                                type='button'
                                color="secondary"
                                onClick={handleSubmit}
                                disabled={!isEmpty(errors)}
                            />

                        </Form>
                    </CardBody>
                </Card>
            </Col>
        </Row>
    );
};

export default BlogFagEdit;